<template>
  <div>
    <loading-component v-if="isLoading" />
    <no-result-component v-else-if="competitions == null || competitions.length <= 0" />
    <div v-else>
      <b-table :data="competitions" ref="table" :striped="true">
        <template slot-scope="props">
          <b-table-column field="name" label="Name">
            <router-link
              :to="{ name: 'bayesiancompetition', params: {competitionId: props.row.id }}"
            >{{ props.row.name }}</router-link>
          </b-table-column>
          <b-table-column field="openFrom" label="Date">{{ formatDate(props.row.openFrom)}}</b-table-column>

          <b-table-column field="theme" label="Classes">
            <p
              v-for="competitionClass in props.row.classes"
              v-bind:key="competitionClass.id"
              :class="competitionClass.cssClass"
              style="margin-right:2px;"
            >{{competitionClass.name}}</p>
          </b-table-column>
          <b-table-column field label="Results">
            <router-link
              v-if="props.row.isResultPublished"
              :to="{ name: 'competitionresults', params: {competitionId: props.row.id }}"
            >View</router-link>
          </b-table-column>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
var moment = require("moment");
moment().format();
import LoadingComponent from "./Loading.vue";
import NoResultComponent from "./NoResult.vue";

export default {
  name: "CompetitionsList",
  components: {
    LoadingComponent,
    NoResultComponent
  },
  props: {
    competitions: null
  },
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    }
  }
};
</script>

<style scoped>
a {
  color: #8c67ef;
}
</style>
